import axios, { AxiosError } from 'axios'

const isProd = process.env.NODE_ENV === 'production'

const apiUrl = isProd ? 'https://app.koradelivery.com/api-kora' : 'http://localhost:3333'

const api = axios.create({
  baseURL: apiUrl,
})

api.interceptors.request.use(
  (request) => {
    if (request.method && ['put', 'post', 'patch'].includes(request.method)) {
      if (request.data) request.data = sanitizeEmptyStrings(request.data)
    }
    return request
  },
  (error: unknown) => {
    if (error instanceof Error) return Promise.reject(error)
    return Promise.reject(new Error('Erro desconhecido ao fazer a requisição'))
  },
)

api.interceptors.response.use(
  (response) => {
    return response
  },
  (error: unknown) => {
    if (error instanceof AxiosError) {
      if (error.response?.status === 401) {
        let is_token_valid = localStorage.getItem('@smartdelivery:is_token_valid')
        if (is_token_valid && is_token_valid === 'true') {
          localStorage.setItem('@smartdelivery:is_token_valid', 'false')
        }
      }
    }
    if (error instanceof Error) return Promise.reject(error)
    return Promise.reject(new Error('Erro desconhecido ao fazer a requisição'))
  },
)

/**
 * Substitui campos que contém strings vazias por `null`, tanto em um JSON quanto em um FormData.
 */
const sanitizeEmptyStrings = (data: unknown): any => {
  if (!data) return data

  if (data instanceof FormData) {
    // FormData: iteramos e ajustamos os valores do campo `data`
    const newFormData = new FormData()
    Array.from(data.entries()).forEach(([key, value]) => {
      // Se for o campo `data`, modifica as strings
      if (key === 'data' && typeof value === 'string') {
        const newValue = convertEmptyStringsToNull(JSON.parse(value))
        newFormData.append('data', JSON.stringify(newValue))
      } else {
        newFormData.append(key, value) // Se não, simplesmente pula insere como estava
      }
    })
    return newFormData
  } else if (typeof data === 'object') {
    // JSON: apenas buscamos no objeto por strings vazias
    data = convertEmptyStringsToNull(data)
  }
  return data
}

/**
 * Espera um JSON. Altera campos que tenham strings vazias e substitui por `null`.
 */
const convertEmptyStringsToNull = (data: Record<string, any>) => {
  for (const key in data) {
    if (data[key] === '') {
      data[key] = null
    } else if (data[key] instanceof Object) {
      // Recursão para objetos aninhados
      data[key] = convertEmptyStringsToNull(data[key])
    }
  }
  return data
}

export default api
